module.exports = __webpack_public_path__ + "media/digital/Testimonial-64b0bf57.png";